// removed by extract-text-webpack-plugin
module.exports = {"myMenu":"_24L-2Cp4fgTPzkDZLSp4ox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/global-style.css
// module id = 347
// module chunks = 0